module.exports = __webpack_public_path__ + "static/desktop-printer-dc6202e725b483d39a77289082bf8272.jpg";